import React from "react";

export default function Alerts() {
  return (
    <div style={{background:'#000', minHeight:'100vh', width:'100%', padding:'24px 0 100px', boxSizing:'border-box'}}>
      <div style={{maxWidth: 800, margin: '0 auto', padding: '0 1.5em 2em', boxSizing:'border-box'}}>
        <h2 style={{
          color: '#fff',
          fontSize: '2.4em',
          fontWeight: 800,
          letterSpacing: '.01em',
          marginBottom: '16px'
        }}>Alertas y Precauciones</h2>
        <div style={{display:'flex',flexWrap:'wrap',gap:'18px',marginTop:'24px',justifyContent:'center'}}>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            Lee el manual antes de operar la prensa.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            No excedas la presión máxima recomendada.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            Utiliza protección térmica y guantes.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            Mantén la prensa en una superficie estable.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            No dejes la prensa desatendida mientras está en uso.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            Las gafas de protección nunca están de más.
          </div>
          <div style={{background:'#fff9c4',color:'#222',padding:'20px 28px',borderRadius:'50px',boxShadow:'0 2px 12px #ffe0b2',fontWeight:600,fontSize:'1.1em',minWidth:220,textAlign:'center',transition:'transform 0.2s',margin:'8px 0'}}>
            Al dejar de usar el equipo, recuerda liberar la prensa, separar los discos y desenchufar de la corriente eléctrica para el modo reposo.
          </div>
        </div>
      </div>
    </div>
  );
}
